import type { FaireProductEntity } from "../../entity_types/product";

export const p_wymgugujxf: FaireProductEntity = {
  token: "p_wymgugujxf",
  type: "product",
  name: "La Fete Mahjong Tiles",
  brandToken: "b_h37p547xcx",
  brandName: "Oh My Mahjong",
  imageUrl:
    "https://cdn.faire.com/fastly/c350de7d7f0d668cadcfd8d02b3890213aebd97712c433e24a46ba6ca5260020.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0856183b973cf5edea75381963bc4482105108ce20651e0c56e307bbca0e0a54.jpeg",
    "https://cdn.faire.com/fastly/f2a00237be81916b168131b135d14246311f7a6d4283163e6e30e03024d82638.jpeg",
    "https://cdn.faire.com/fastly/8f8f42b4e1fb3fa156ee401b4f91b6cc00c6ee8f1436db3f1bb54c8bfd9ce6c1.jpeg",
    "https://cdn.faire.com/fastly/683bd86a3001d9882e000e4f4640b9eada88f5181327090cec1c4da4cb934cc8.jpeg",
    "https://cdn.faire.com/fastly/0167520ab20cbf0e44fe5120bb6f2b8b1a6be92438076d7b66b0f8766d06a269.jpeg",
    "https://cdn.faire.com/fastly/b539381bc7297f0c9707f24ea6b49f350aef134430dfef806c5b9f0061680c59.jpeg",
    "https://cdn.faire.com/fastly/304a4c26b2deaf82ab027ae66e3ad24f421102c3008b78e8b037d3a2979792df.jpeg",
    "https://cdn.faire.com/fastly/c2fb2a705789190b08df6b9df64861fec8e8e4ea83df9a396f5f3b9add477b14.jpeg",
  ],
  priceDollars: 220,
  description:
    "Introducing La Fete Tile Line: the ultimate choice for gamers seeking stylish flair for their game nights. Meticulously crafted and hand-painted, these Mahjong tiles blend classic charm with a modern twist. With a vibrant palette of olive green, baby pink, and teal, they bring a celebratory vibe to every game. Elevate your gaming experience with the trendiest Mahjong tiles around.\n\nSet includes Tiles, Dice/Coin Bag and 4 Instructional Cards (If playing American Mahjong, will need to purchase NMJL Playing Card separately).\n\n𝐓𝐢𝐥𝐞𝐬:\n• 160 Acrylic Tiles\n• 1-9 Bams, Cracks and Dots (4 of each) = 108\n• N E W S (4 of each) = 16\n• Red, Green and White Dragon (4 of each) = 12\n• Flowers = 8\n• Jokers = 10\n• Blanks = 6\n\nIndividual Tiles Size: .87” Wide x .75” Deep x 1.25” Tall",
  tags: [],
  msrpDollars: 400,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:37.154Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
